module.exports = __webpack_public_path__ + "img/foto5.c3c4230e.jpg";